type TimeRange = "1d" | "7d" | "1m" | "6m" | "1y";

// Format number to 2 decimal places
export const formatNumber = (value: number): string => {
  return value.toFixed(2);
};

// Format date for display in breakdown
export const formatDate = (
  dateString: string,
  timeRange: TimeRange,
): string => {
  const date = new Date(dateString);

  switch (timeRange) {
    case "7d":
      return date.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    case "1m":
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    case "6m":
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    case "1y":
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    default:
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
  }
};

// Generate tooltip time label
export const generateTooltipTimeLabel = (
  selectedRange: TimeRange,
  index: number,
  filteredData: {
    date: string;
    low: number;
    high: number;
    avg: number;
    hour?: number;
    datetime?: string;
  }[],
): string => {
  if (filteredData.length === 0) return "";

  const item = filteredData[index];

  if (selectedRange === "1d") {
    return `${item.hour ?? 0}:00`;
  } else {
    const date = new Date(item.date);

    switch (selectedRange) {
      case "7d":
        return date.toLocaleDateString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric",
          year: "numeric",
        });
      case "1m":
        return date.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        });
      case "6m":
        return date.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        });
      case "1y":
        return date.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        });
      default:
        return date.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        });
    }
  }
};

// Create tooltip label for chart points
export const createTooltipLabel = (
  timeLabel: string,
  lowValue: number,
  highValue: number,
  index: number,
  filteredData: {
    date: string;
    low: number;
    high: number;
    avg: number;
    hour?: number;
    datetime?: string;
  }[],
  isHighPoint = false,
): string => {
  const item = filteredData[index];
  const avgValue = item.avg;

  if (isHighPoint) {
    return `${timeLabel}\nHigh: ${formatNumber(highValue)} mg/dL\nAvg: ${formatNumber(avgValue)} mg/dL\nLow: ${formatNumber(lowValue)} mg/dL`;
  } else {
    return `${timeLabel}\nLow: ${formatNumber(lowValue)} mg/dL\nAvg: ${formatNumber(avgValue)} mg/dL\nHigh: ${formatNumber(highValue)} mg/dL`;
  }
};
